import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import { getIncomeService } from '../../services/income.service';
import moment from "moment-timezone";

const IncomeDetails = () => {
    const [incomeData, setIncomeData] = useState([]);


        const dispatch = useDispatch();
         moment.locale('en');

        // load incomeData and reload incomeData when form submit [useEffect]
        useEffect(() => {
            const controller = new AbortController();
            const signal = controller.signal;
            getIncomeData(signal);

            return () => {
                controller.abort();
            }
        },[]);

        const getIncomeData = async (signal) => {
            dispatch(setIsLoading(true))

            try {
                const result = await getIncomeService(signal);
                if(result.data) {
                    setIncomeData(result.data)
                }
            } catch (error) {
                const errorMessage =
                    error?.response?.data?.error?.includes('streaming buffer')
                        ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                        : error?.response?.data?.message || error?.message;

                dispatch(
                    setToastMessage({
                        message: errorMessage,
                        type: "error",
                    })
                );
            } finally {
            dispatch(setIsLoading(false))
            }
        }

        // const groupedData = incomeData.reduce((acc, current) => {
        //     const date = current.incomeDate.value;
        //     if (!acc[date]) {
        //         acc[date] = [];
        //     }
        //     acc[date].push(current);

        //     return acc;
        // }, {});

        // const sortedArray = Object.entries(groupedData).sort(([, a], [, b]) => b.length - a.length);
        // const sortedGroupedData = Object.fromEntries(sortedArray);


        return (
            <div>
                <div className='bg-white rounded-sm h-[90dvh] mx-2 my-2'>
                    <div className='w-[100%] h-[90%]'>

                        <div className='pl-5 py-10 '>
                            <h1 className='text-lg text-userText font-semibold'>» Income Details «</h1>
                        </div>
                        <div className="w-[90%] h-[90%] text-sm font-normal mx-auto  overflow-y-auto">
                            {   incomeData.length > 0 ?
                                <table className='w-full md:w-[100%] mx-auto text-fgColor font-semibold'>

                                <tbody>
                                    {incomeData.map((item, idx) => (
                                        <tr className="border-b-2 border-borderColor" key={idx}>
                                            <td className="w-[25%] text-primary font-semibold text-left py-5 px-3 md:px-5 h-12">
                                                <div>{item.username}</div>
                                                <div className='text-xs text-textcol'>{item.dateTime ? moment.utc(item.dateTime.value)
                                                .tz('Asia/Yangon')
                                                .format("DD/MM/YYYY")
                                                : "Invalid Date"}
                                                </div>
                                            </td>
                                            <td className="w-[25%] text-left md:px-5 h-12 overflow-hidden">
                                                <div>{item.transferType}</div>
                                                <div>{item.description}</div>
                                                {/* <div className='text-xs'>{item.description}</div> */}
                                            </td>

                                            <td className="w-[25%] text-right md:px-5 h-12 overflow-hidden">{item.amount.toLocaleString()}</td>
                                        </tr>
                                        ))}
                                </tbody>
                            </table>
                        :
                            <div className='w-full h-full flex items-center justify-center font-semibold'>
                                <h1 className='text-lg'>No Data To Show</h1>
                            </div>
                        }
                        </div>
                    </div>
                </div>
            </div>
        )
}

export default IncomeDetails
